const fetch = require('app/www/libs/client/fetch');
const RESOURCE = require('app/configs/_routes').search.api.base;

module.exports = {

    search(params) {
        const {regionId, text, page, type} = params;
        return fetch(RESOURCE.replace(/\:regionId\(\\d\+\)\?/gi, regionId), {text, page, type});
    },

};
